import React from 'react';

import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import {
    StyledComment,
    StyledEventContainer,
    StyledEventKey,
    StyledEventValue,
    StyledLink,
} from './AccountActivity.styled';
import { IAccountActivityEvent } from './common/types';
import { FormattedMessage } from 'react-intl';

interface IEventCommentsProps {
    item: IAccountActivityEvent;
    fetchComments: (eventId: string) => void;
}

export const EventComments = ({ item, fetchComments }: IEventCommentsProps) => {
    const { isCommentFetched, comments = [], id } = item;
    const hasComments = comments.length > 0;

    return (
        <StyledEventContainer data-testid={`${id}-event-comment-container`} columns="2">
            <StyledEventKey data-testid="comment-key">
                <FormattedMessage id="member.account.activity.comments" />
            </StyledEventKey>
            <StyledEventValue>
                <ConditionalRendering isTrue={hasComments}>
                    {comments.map((comment: any, index: number) => (
                        <StyledComment data-testid={`comment-${index}-value`} id={`comment_${index}`} key={index}>
                            {comment}
                        </StyledComment>
                    ))}
                </ConditionalRendering>
                <ConditionalRendering isTrue={isCommentFetched && !hasComments}>
                    <StyledComment>
                        <i data-testid="no-comments">
                            <FormattedMessage id="member.account.activity.no.comments" />
                        </i>
                    </StyledComment>
                </ConditionalRendering>
                <ConditionalRendering isTrue={!isCommentFetched}>
                    <StyledLink data-testid="show_comments_btn" id="show_comments_btn" onClick={() => fetchComments(id)}>
                        <FormattedMessage id="member.account.activity.show.comments" />
                    </StyledLink>
                </ConditionalRendering>
            </StyledEventValue>
        </StyledEventContainer>
    );
};
